export default __webpack_public_path__ + "static/media/Instagramm_grün.812a7375.png";